import React, { Component } from 'react';
import { Field, reduxForm, reset, submit } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import EventTimeline from 'components/shared/EventTimeline';
import { submitNote, getNotes, clearNotes } from 'actions/maintenanceTicketActions';
import * as validator from 'helpers/Validator';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';
import { localize } from 'react-localize-redux';
import { BounceLoader } from 'halogenium';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { getTranslatedString } from 'helpers/i18n';

import Header from 'components/shared/Header';

import withMobileDialog from '@material-ui/core/withMobileDialog';

let TenantMaintenanceNotesForm = class extends Component {
  render() {
    const { translate, isResident, handleSubmit, remoteSubmit, submitting } = this.props;

    const tenantCommunicationsDescriptionOptions = {
      serviceRequest: translate('tenantCommunicationsDescription'),
      requestForMaintenance: translate('tenantCommunicationsDescriptionRFM'),
    };

    const residentCommunicationsDescriptionOptions = {
      serviceRequest: translate('residentCommunicationsDescription'),
      requestForMaintenance: translate('residentCommunicationsDescriptionRFM'),
    };

    const tenantPortalCommunicationsDescriptionOptions = {
      serviceRequest: translate('tenantPortalCommunicationsDescription'),
      requestForMaintenance: translate('tenantPortalCommunicationsDescriptionRFM'),
    };

    const readOnly = hostIsBoardwalk();
    const isHiddenForBwalk = hostIsBoardwalk() && !isResident;
    let hintText = null;

    if (!isResident && !readOnly) {
      hintText = (
        <TenantResidentVerbiageHelper
          translatedTenant={serviceRequestOptions(tenantCommunicationsDescriptionOptions)}
          translatedResident={serviceRequestOptions(residentCommunicationsDescriptionOptions)}
        />
      );
    } else if (isResident) {
      hintText = serviceRequestOptions(tenantPortalCommunicationsDescriptionOptions);
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xs-12" style={{ margin: 'auto', textAlign: 'initial', padding: 0 }}>
            <label style={{ width: '100%' }}>
              <Field
                name="text"
                component={TextField}
                aria-label={getTranslatedString('messaging')}
                style={{ fontSize: '14px' }}
                validate={[validator.required]}
                hintText={hintText}
                disabled={isHiddenForBwalk}
                fullWidth
                multiLine
                rows={4}
              />
            </label>
          </div>
        </div>
        <div className="row" style={{ textAlign: 'center', margin: '5px 0 15px' }}>
          {!isHiddenForBwalk && (
            <FlatButton
              label={translate('send')}
              onClick={() => remoteSubmit('tenant_maintenance_notes')}
              style={{
                backgroundColor: submitting ? colors.GRAY : AccentColor(),
                color: '#fff',
              }}
              disabled={submitting}
            />
          )}
        </div>
      </form>
    );
  }
};
TenantMaintenanceNotesForm = reduxForm({
  form: 'tenant_maintenance_notes',
})(localize()(TenantMaintenanceNotesForm));

let TenantNotesDialogContent = class extends Component {
  componentDidMount() {
    this.props.getNotes(this.props.ticketId, { hide_stale: true });
  }

  componentWillUnmount() {
    this.props.clearNotes();
  }

  createTenantMaintenanceNote = (note) => {
    return this.props.submitNote(note, this.props.ticketId).then(() => {
      this.props.reset('tenant_maintenance_notes');
      this.props.getNotes(this.props.ticketId, { hide_stale: true });
    });
  };

  render() {
    return (
      <div>
        <Header
          name={
            <TenantResidentVerbiageHelper
              translatedTenant={this.props.translate('tenantCommunications')}
              translatedResident={this.props.translate('residentCommunications')}
            />
          }
          style={{ margin: '0 -25px', textTransform: 'uppercase' }}
        />
        <div style={{ padding: '0 30px' }}>
          {this._renderTicketNotes()}
          {this._renderTicketNoNotes()}
          {!this.props.readOnly && (
            <div className="row">
              <TenantMaintenanceNotesForm
                onSubmit={this.createTenantMaintenanceNote}
                remoteSubmit={this.props.remoteSubmit}
                isResident={this.props.isResident}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  _renderTicketNotes = () => {
    if (this.props.maintenanceTicketNotes.length === 0) return;

    const translatedNotes = this.props.maintenanceTicketNotes.map((note) => {
      return {
        ...note,
        title: getTranslatedString('landlordPortal.ticketDetailsOverview.noteAddedBy', {
          author: note.author,
        }),
      };
    });
    return <EventTimeline events={translatedNotes} />;
  };

  _renderTicketNoNotes = () => {
    if (this.props.fetchingNotes)
      return (
        <BounceLoader color={AccentColor()} style={{ display: 'flex', justifyContent: 'center' }} />
      );
    if (this.props.maintenanceTicketNotes.length !== 0) return;

    const noneOptions = {
      serviceRequest: this.props.translate('maintenanceNotes.none'),
      requestForMaintenance: this.props.translate('maintenanceNotes.noneRFM'),
    };

    return (
      <div className="row" style={{ padding: '15px' }}>
        <p style={{ textAlign: 'center' }}>{serviceRequestOptions(noneOptions)}</p>
      </div>
    );
  };
};
TenantNotesDialogContent = connect(
  (store) => ({
    maintenanceTicketNotes: store.maintenanceTicket.maintenanceTicketNotes,
    fetchingNotes: store.maintenanceTicket.fetchingNotes,
    tenantDetails: store.landlordTenants.tenantDetails,
    tenantLeadID: store.landlordTenants.leadId,
  }),
  {
    remoteSubmit: submit,
    getNotes,
    clearNotes,
    submitNote,
    reset,
  }
)(TenantNotesDialogContent);

let TenantMaintenanceNotes = class extends Component {
  state = {
    dialogOpen: false,
  };

  render() {
    return (
      <div className="row">
        <TenantNotesDialogContent
          translate={this.props.translate}
          ticketId={this.props.ticketId}
          isResident={this.props.isResident}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }
};

export default withMobileDialog()(localize()(TenantMaintenanceNotes));
